import React from 'react'
import machine from '../img/machine.jpg'
import ExploreBox1 from './ExploreBox1';
import { useNavigate } from 'react-router-dom';
import ExploreboxAccordian1 from './ExploreboxAccordian1';


const Explore1 = (props) => {


    const history=useNavigate();
    const registerPage=(register)=>{
    window.open(register)
    }
  

    return (
        <>
     <div className="explore">
               <div className="explore__wrapper"></div>
               <div className="explore__content">
                   <div className="explore__left">
                          <img src={props.img} alt="" />
                          <button onClick={()=>registerPage(props.register)}>Register</button>
                          <a href={props.moviet1} download>content</a>
                   </div>
                   {/* /* /////////// */ }
                   <div className="explore__right">
                        <h1>{props.name}</h1>
                        <p>{props.des}</p>
                        <h3>inr {props.cost}</h3>
                        <ExploreboxAccordian1 date1={props.date} date2={props.date1} date3={props.date2} first={props.first} para1={props.para1} para2={props.para2} para3={props.para3} para4={props.para4} person={props.person} mail={props.mail} contact={props.contact}  />
                        <ExploreBox1 date1={props.date} date2={props.date1} date3={props.date2} first={props.first} para1={props.para1} para2={props.para2} para3={props.para3} para4={props.para4} person={props.person} mail={props.mail} contact={props.contact}  />
                   </div>
               </div>
           </div>
        </>
    )
}

export default Explore1
